import { Card, Text } from "@mantine/core";
import { motion } from "framer-motion";
import { IconPlus } from "@tabler/icons-react";

export default function AddRoomCard({ openCreate }) {

  return (

    <motion.div whileHover={{ y: -6 }}>

      <Card
        radius="xl"
        withBorder
        onClick={openCreate}
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          borderStyle: "dashed"
        }}
      >

        <div style={{ textAlign: "center" }}>

          <IconPlus size={40} color="#6366f1" />

          <Text mt="sm" fw={500}>
            Ajouter une chambre
          </Text>

        </div>

      </Card>

    </motion.div>

  );
}